import React from 'react';

type Props = {
  condition: boolean;
  children: React.ReactNode;
  wrapper: (props: { children: React.ReactNode }) => React.ReactElement;
};

const ConditionalWrapper = ({ condition, children, wrapper: Wrapper }: Props) => {
  if (!condition) return <>{children}</>;
  return <Wrapper>{children}</Wrapper>;
};

export default ConditionalWrapper;
